/**
 * Realtime transport types (backend ADR-021, FE-ADR-017).
 *
 * `core/realtime` is deliberately domain-agnostic: it moves opaque payloads
 * from a channel to a handler. Features narrow the payload themselves, so this
 * module never imports from `features/`.
 */

/** What the UI may show about the socket. `disabled` = no VITE_CENTRIFUGO_URL. */
export type RealtimeStatus = 'disabled' | 'disconnected' | 'connecting' | 'connected';

/** `POST /api/realtime/token/` */
export interface RealtimeTokenDto {
  token: string;
  /** Public WebSocket origin, when the deployment publishes one. May be blank. */
  ws_url_hint: string;
  expires_in: number;
}

/** `POST /api/realtime/subscribe-token/` */
export interface SubscribeTokenDto {
  token: string;
  channel: string;
  expires_in: number;
}

/** Called with each publication's `data`. */
export type PublicationHandler<T = unknown> = (data: T) => void;

/** Removes one handler; the underlying subscription drops when the last goes. */
export type Unsubscribe = () => void;

// ---------------------------------------------------------------------------
// Channel names — mirrored from the backend's realtime/channels.py. These two
// shapes are the ONLY subscribable channels; anything else is a 403 at the
// token endpoint.
// ---------------------------------------------------------------------------
export const threadChannel = (threadPublicId: string): string => `thread:${threadPublicId}`;
export const userChannel = (memberPublicId: string): string => `user:${memberPublicId}`;
